import { useQuery } from '@tanstack/react-query';
import { awpDocumentsKey, mapToAwpDocument, requestMyAwpResults } from './awpDocumentsApi';

/** The member's AWP documents. Pass `enabled: false` until the list is actually shown. */
export function useAwpDocuments({ enabled }: { enabled: boolean }) {
  const { data, isPending, isError, refetch } = useQuery({
    queryKey: awpDocumentsKey,
    queryFn: requestMyAwpResults,
    select: (raw) => raw.myAwpResults.map(mapToAwpDocument),
    enabled,
  });

  return { data, isPending, isError, refetch: () => void refetch() };
}
